import {useCallback, useEffect, useMemo} from "react";
import useApiRequest from "../../hooks/useApiRequest";
import SearchBar from "../ui/SearchBar";

const normalizeArray = (value) => {
  if (Array.isArray(value?.data)) return value.data;
  if (Array.isArray(value?.items)) return value.items;
  if (Array.isArray(value?.results)) return value.results;
  if (Array.isArray(value)) return value;
  return [];
};

const ScopeRolesFilterBar = ({scopeId, onSearch}) => {
  const {list: listProducts} = useApiRequest({baseUrl: "/products", resource: "products"});

  const loadProducts = useCallback(async () => {
    const res = await listProducts();
    return normalizeArray(res?.data).map((p) => ({id: p.id, label: p.name || p.id}));
  }, [listProducts]);

  // Reset the grid whenever the selected scope changes.
  useEffect(() => {
    onSearch({});
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [scopeId]);

  const fields = useMemo(
    () => [{field: "product_id", label: "Producto", type: "autocomplete", width: 220, loadOptions: loadProducts}],
    [loadProducts]
  );

  // key={scopeId} remounts (and thus clears) the bar when the scope changes.
  return (
    <div style={{marginBottom: 16}}>
      <SearchBar key={scopeId} fields={fields} onSearch={onSearch} />
    </div>
  );
};

export default ScopeRolesFilterBar;
